<template>
  <combo-tree-common v-bind="$props" v-on="$listeners" />
</template>
<script>
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeNavigation',
  props: {
    pathName: {
      type: String, default: '/cms/navigation/tree'
    },
    eventName: {
      type: String, default: 'refresh--comno-tree-navigation'
    },
    parameter: {
      type: Object, default () { return { classify: 'PORTAL' } }
    }
  }
}
</script>
